import { Button } from '@mui/material';
import { LinkNavigationContainer } from './styles';

const NavigationLinks = ({ numberOfSimulations, partDefinition, simulationRefs }) => {
	const scrollToRef = ref => {
		const yOffset = -60;
		const y = ref.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });
	};

	return (
		<LinkNavigationContainer>
			{Array.from({ length: numberOfSimulations }, (_, index) => (
				<Button
					variant="standart"
					key={`toggle-${index}`}
					onClick={() => scrollToRef(simulationRefs.current[index])}
					size="large"
					sx={{ mx: 1, color: 'blue' }}>
					{partDefinition.simulations[index].heading}
				</Button>
			))}
		</LinkNavigationContainer>
	);
};

export default NavigationLinks;
